export default "__VITE_ASSET__BPBFWARg__"